import { Box, Divider, withStyles } from "@material-ui/core";
import {
  AccountBalanceWallet,
  Description,
  ExitToApp,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  LocationCity,
  
  // WbSunny,
  VpnKey,
  MonetizationOn,
  Subject
} from "@material-ui/icons";
import FileUpload from '@material-ui/icons/CloudUpload';
import React from "react";
import { Link } from "react-router-dom";
import { GritLogo } from "src/assets/GritLogo";
import SidebarLink from "src/components/sidebar/components/SidebarLink/SidebarLink";
import {
  CLOSE_MENU,
  ENQUIRY_PLAN,
  OPEN_MENU,
  SCHOOLS,
  // SEASONS,
  SIGN_OUT,
  CHANGE_PASS,
  SUBJECTS,
  SUBSCRIPTION_PLAN,
  TEMPLATES,
  VIDEO_UPLOAD,
} from "./constants";
import { styles } from "./styles";
import { IProps } from "./types";

export const AdminSidebar = withStyles(styles)(
  class extends React.Component<IProps> {
    public render() {
      const { classes, isSidebarOpen, toggleIsSidebarOpen } = this.props;
      return (
        <Box className={classes.sidebar}>
          <Box className={classes.sidebarBackground}>
            <Box
              className={classes.innerSidebar}
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box>
                <Link to="/">
                  <GritLogo
                    className={classes.gritLogo}
                    isSidebarOpen={isSidebarOpen}
                  />
                </Link>
                <Divider className={classes.divider} />
                <Box display="flex" flexDirection="column" gridGap="1rem">
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<Description />}
                    to="/admin/templates"
                    title={TEMPLATES}
                    tooltipTitle={TEMPLATES}
                  />
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<LocationCity />}
                    to="/admin/schools"
                    title={SCHOOLS}
                    tooltipTitle={SCHOOLS}
                  />
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<Subject/>}
                    to="/admin/sports"
                    title={SUBJECTS}
                    tooltipTitle={SUBJECTS}
                  />
                  {/* <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<WbSunny />}
                    to="/admin/seasons"
                    title={SEASONS}
                    tooltipTitle={SEASONS}
                  /> */}
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<FileUpload />}
                    to="/admin/upload-video"
                    title={VIDEO_UPLOAD}
                    tooltipTitle={VIDEO_UPLOAD}
                  />
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<AccountBalanceWallet />}
                    to="/admin/subscription-page"
                    title={SUBSCRIPTION_PLAN}
                    tooltipTitle={SUBSCRIPTION_PLAN}
                  />
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<MonetizationOn />}
                    to="/admin/inquire"
                    title={ENQUIRY_PLAN}
                    tooltipTitle={ENQUIRY_PLAN}
                  />
                </Box>
              </Box>
              <Box>
                <Divider className={classes.divider} />
                <Box display="flex" flexDirection="column" gridGap="1rem">
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    tooltipTitle={OPEN_MENU}
                    icon={
                      isSidebarOpen ? (
                        <KeyboardArrowLeft />
                      ) : (
                        <KeyboardArrowRight />
                      )
                    }
                    title={CLOSE_MENU}
                    action={() =>
                      toggleIsSidebarOpen((prevState) => !prevState)
                    }
                  />
                    <div className="logout-link">
                                          <SidebarLink
                                            isSidebarOpen={isSidebarOpen}
                                            tooltipTitle={CHANGE_PASS}
                                            icon={<VpnKey />}
                                            to="/reset/password/new?status=sidebar"
                                            title={CHANGE_PASS}
                                          />
                                        </div>
                  <SidebarLink
                    isSidebarOpen={isSidebarOpen}
                    icon={<ExitToApp />}
                    to="/logout"
                    title={SIGN_OUT}
                    tooltipTitle={SIGN_OUT}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/pages/admin/AdminSidebar/AdminSidebar.tsx